export default __webpack_public_path__ + "src/assets/icons/CarMap-4189bf3b.svg";